// import React from "react";

// export default function Contact() {
//   return (
//     <section id="contact" className="py-5 bg-light">
//       <div className="container">
//         <h2 className="h3 mb-4">Contact Us</h2>
//         <div className="row">
//           <div className="col-lg-6">
//             <form onSubmit={(e)=>{e.preventDefault(); alert('Form submitted — add API later')}}>
//               <div className="mb-3">
//                 <label className="form-label">Name</label>
//                 <input className="form-control" required />
//               </div>
//               <div className="mb-3">
//                 <label className="form-label">Email</label>
//                 <input type="email" className="form-control" required />
//               </div>
//               <div className="mb-3">
//                 <label className="form-label">Message</label>
//                 <textarea className="form-control" rows="4" required></textarea>
//               </div>
//               <button className="btn btn-primary">Send</button>
//             </form>
//           </div>
//           <div className="col-lg-6">
//             <div className="p-4 border rounded bg-white">
//               <h5>Get in touch</h5>
//               <p className="mb-0 text-muted">Email: hello@mymarket.com</p>
//               <p className="mb-0 text-muted">Phone: +91 98765 43210</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }


// import { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";

// export default function Contact() {
//   const [result, setResult] = useState("");
//   const [loading, setLoading] = useState(false);

//   const onSubmit = async (event) => {
//     event.preventDefault();
//     setLoading(true);
//     setResult("");

//     const formData = new FormData(event.target);
//     formData.append("access_key", "6667d557-26b2-4e69-897c-f4d756f7baaf");

//     const response = await fetch("https://api.web3forms.com/submit", {
//       method: "POST",
//       body: formData,
//     });

//     const data = await response.json();

//     if (data.success) {
//       setResult("✅ Message sent successfully!");
//       event.target.reset();
//     } else {
//       setResult("❌ Something went wrong. Please try again.");
//     }

//     setLoading(false);
//   };

//   return (
//     <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
//       <form
//         onSubmit={onSubmit}
//         className="bg-white shadow p-5 rounded w-100"
//         style={{ maxWidth: "500px" }}
//       >
//         <h2 className="text-center mb-4 text-primary">Contact Us</h2>

//         <div className="mb-3">
//           <label htmlFor="name" className="form-label fw-semibold">
//             Name
//           </label>
//           <input
//             type="text"
//             name="name"
//             id="name"
//             className="form-control"
//             placeholder="John Doe"
//             required
//           />
//         </div>

//         <div className="mb-3">
//           <label htmlFor="email" className="form-label fw-semibold">
//             Email
//           </label>
//           <input
//             type="email"
//             name="email"
//             id="email"
//             className="form-control"
//             placeholder="you@example.com"
//             required
//           />
//         </div>

//         <div className="mb-4">
//           <label htmlFor="message" className="form-label fw-semibold">
//             Message
//           </label>
//           <textarea
//             name="message"
//             id="message"
//             className="form-control"
//             rows="4"
//             placeholder="Write your message..."
//             required
//           ></textarea>
//         </div>

//         <button
//           type="submit"
//           className="btn btn-primary w-100 fw-semibold"
//           disabled={loading}
//         >
//           {loading ? (
//             <>
//               <span
//                 className="spinner-border spinner-border-sm me-2"
//                 role="status"
//                 aria-hidden="true"
//               ></span>
//               Sending...
//             </>
//           ) : (
//             "Send Message"
//           )}
//         </button>

//         {result && (
//           <div
//             className={`alert mt-4 text-center ${
//               result.includes("✅") ? "alert-success" : "alert-danger"
//             }`}
//             role="alert"
//           >
//             {result}
//           </div>
//         )}
//       </form>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Contact() {
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
        // Scroll to top when this page is mounted
        window.scrollTo(0, 0);
      }, []);

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setResult("");

    const formData = new FormData(event.target);
    formData.append("access_key", "6667d557-26b2-4e69-897c-f4d756f7baaf");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("✅ Message sent successfully!");
      event.target.reset();
    } else {
      setResult("❌ Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div>
      <section
      id="contact"
      className="py-5 mt-4"
      // style={{
      //   background:
      //     "linear-gradient(135deg, #ffffff 0%, #f9fafb 40%, #eef1f5 100%)",
      // }}
    >
      <div className="container d-flex flex-column align-items-center justify-content-center">
        {/* 🧾 Section Heading */}
        <motion.h2
          className="fw-bold mb-3 text-center"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          style={{
            fontSize: "2.2rem",
          }}
        >
          Get in{" "}
          <span
            style={{
              background: "linear-gradient(90deg,#ff006e,#ff8c00)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Touch
          </span>
        </motion.h2>

        <motion.p
          className="text-black text-center mb-5"
          style={{ maxWidth: "700px", lineHeight: "1.7" }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Have a question, project idea, or collaboration in mind? Let’s connect
          and build something amazing together.
        </motion.p>

        {/* 💌 Contact Form */}
        <div className="container d-flex flex-column align-items-center justify-content-center gap-5">
          <motion.form
          onSubmit={onSubmit}
          className="bg-white shadow-lg p-5 rounded-4 w-100"
          style={{ maxWidth: "600px" }}
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
        >
          <motion.div
            className="mb-3"
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
          >
            <label htmlFor="name" className="form-label fw-semibold">
              Name
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="form-control rounded-3"
              placeholder="John Doe"
              required
            />
          </motion.div>

          <motion.div
            className="mb-3"
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
          >
            <label htmlFor="email" className="form-label fw-semibold">
              Email
            </label>
            <input
              type="email"
              name="email"
              id="email"
              className="form-control rounded-3"
              placeholder="you@example.com"
              required
            />
          </motion.div>

          <motion.div
            className="mb-4"
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
          >
            <label htmlFor="message" className="form-label fw-semibold">
              Message
            </label>
            <textarea
              name="message"
              id="message"
              className="form-control rounded-3"
              rows="4"
              placeholder="Write your message..."
              required
            ></textarea>
          </motion.div>

          <motion.button
            type="submit"
            className="btn w-100 fw-semibold py-2 rounded-pill"
            disabled={loading}
            whileHover={{
              scale: 1.05,
              boxShadow: "0 10px 25px rgba(255,0,110,0.25)",
            }}
            whileTap={{ scale: 0.97 }}
            style={{
              background:
                "linear-gradient(90deg, rgba(255,0,110,1) 0%, rgba(255,140,0,1) 100%)",
              border: "none",
              color: "#fff",
              transition: "all 0.3s ease",
            }}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Sending...
              </>
            ) : (
              "Send Message"
            )}
          </motion.button>

          {/* ✅ Result Message */}
          {result && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className={`alert mt-4 text-center ${
                result.includes("✅") ? "alert-success" : "alert-danger"
              }`}
              role="alert"
            >
              {result}
            </motion.div>
          )}
        </motion.form>
        
        </div>
      </div>
    </section>
    </div>
  );
}
